import routeStatusOptions from '@/constants/routeStatusOptions';

// The leg of an order-row that a route assignment/removal acts on: the pickup
// leg is tracked by pickup_route_id, every other leg (dropoff / FULL) by
// dropoff_route_id. Mirrors buildAssignMutations' prevRouteKey resolution.
export const rowRouteId = (order) =>
    order?.crossdock_leg === 'pickup' ? order?.pickup_route_id : order?.dropoff_route_id;

// Shared eligibility rule for moving an order-row onto a different route: only
// rows that are unassigned, or on a route still in planning, can be pulled off
// their current route. Both the assign flow (useAssignToRoute) and the live
// stat preview (usePreviewOrders) filter through this, so the route card and
// stops panel never project changes that assignment would silently skip.
export const orderIsReassignable = (order, routesByKey) => {
    const prevRoute = routesByKey?.[rowRouteId(order)];
    return !prevRoute || prevRoute.status === routeStatusOptions.PLANNING.value;
};
